export default "__VITE_ASSET__j3yY_MHQ__"